import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AddressFlow from '../../../user-flow/individual/revampedUserFlow/address/AddressFlow';
import { AppDispatch, UserFlowReducer } from '../../../../store.type';
import {
  getUserFlowReducer,
  selectNewBeneState,
  selectTransactionDetails,
  selectUserSessionReducer,
  selectUserStatusReducer
} from '@Redux/selectors';
import { BeneficiaryFlowState } from '../../types';
import { handleBeneSubmit } from '../bank-details/utils/methods';
import { RecipientAddressProps } from './utils/types';
import { BENE_FORM } from '../../constants/commons';
import { scrollToTop } from '@Redux/actions/ui-trigger';

const RecipientAddress: React.FC<RecipientAddressProps> = (props) => {
  const { is_partially_editable, is_completely_editable } = window.history.state?.usr || {};

  const dispatch = useDispatch<AppDispatch>();
  const parentState = props?.parentState || {};
  const { isRedirectedFromSendMoney, beneState: bankDetails, isEditFlow } = parentState;

  const {
    formValues: currentFormValues,
    isBeneSchemaEnabled,
    payoutApiResponse,
    currentBene,
    addressConfig = {},
    currentBeneId: beneId
  } = useSelector(selectNewBeneState) as BeneficiaryFlowState;

  const userStatusReducer = useSelector(selectUserStatusReducer);
  const transactionDetails = useSelector(selectTransactionDetails);
  const { user_session } = useSelector(selectUserSessionReducer);
  const { timeline, screens } = useSelector(getUserFlowReducer) as UserFlowReducer;

  const onSubmit = async (values: any) => {
    const valuesToSubmit = {};
    if (!isBeneSchemaEnabled) {
      Object.keys(addressConfig).forEach((key) => {
        if (values[key] !== undefined) {
          //@ts-ignore
          valuesToSubmit[key as string] = values[key];
        }
      });
    }

    const updatedFormValues = {
      ...currentFormValues,
      ...(!isBeneSchemaEnabled ? valuesToSubmit : values)
    };

    const config_id = currentBene?.beneficiary_routing_config_id;
    const additionalData = {
      user_session,
      userStatusReducer,
      transactionDetails,
      screens,
      timeline,
      config_id,
      is_partially_editable,
      is_completely_editable,
      beneId,
      bankDetails,
      isEditFlow,
      currentFormBeneAddress: !isBeneSchemaEnabled ? valuesToSubmit : values
    };
    await handleBeneSubmit(
      updatedFormValues,
      isBeneSchemaEnabled,
      '',
      dispatch,
      BENE_FORM,
      additionalData,
      isRedirectedFromSendMoney,
      true,
      payoutApiResponse
    );

    dispatch(scrollToTop());
  };

  return <AddressFlow isEditFlow={isEditFlow} isBeneAddressFlow onSubmitBeneFlow={onSubmit} />;
};

export default RecipientAddress;
